import React, { useEffect, useState } from 'react';
import { TimelineEvent, OrderStatus } from '../types';
import { api } from '../services/api';
import { supabase } from '../services/supabase';
import { Check, Clock, AlertTriangle, FileUp, PenTool, Truck } from 'lucide-react';

interface OrderTimelineProps {
   orderId: string;
}

export const OrderTimeline = ({ orderId }: OrderTimelineProps) => {
   const [events, setEvents] = useState<TimelineEvent[]>([]);

   useEffect(() => {
      loadTimeline();

      const channel = supabase
         .channel(`timeline:${orderId}`)
         .on('postgres_changes', {
            event: 'INSERT',
            schema: 'public',
            table: 'timeline_events',
            filter: `order_id=eq.${orderId}`
         }, () => {
            loadTimeline();
         })
         .subscribe();

      return () => { supabase.removeChannel(channel); };
   }, [orderId]);

   const loadTimeline = async () => {
      const data = await api.getTimeline(orderId);
      setEvents(data);
   };

   const getIcon = (title: string, status?: string) => {
      if (title.includes('Created')) return <Clock size={14} />;
      if (status === OrderStatus.DELIVERED) return <Truck size={14} />;
      if (status === OrderStatus.NEEDS_REVIEW) return <AlertTriangle size={14} />;
      if (title.includes('Submitted')) return <FileUp size={14} />;
      return <PenTool size={14} />;
   };

   return (
      <div className="relative pl-4 border-l border-border space-y-6">
         {events.map((event, idx) => (
            <div key={event.id} className="relative group">
               <div className="absolute -left-[21px] top-1 w-3 h-3 rounded-full bg-surface border-2 border-secondary group-hover:border-blue-500 transition-colors flex items-center justify-center">
               </div>

               <div className="bg-surfaceHighlight rounded-lg p-3 border border-border hover:border-secondary transition-colors">
                  <div className="flex justify-between items-start mb-1">
                     <h4 className="font-bold text-sm text-primary flex items-center gap-2">
                        {getIcon(event.title, event.status)}
                        {event.title}
                     </h4>
                     <span className="text-[10px] text-secondary font-mono">
                        {new Date(event.createdAt).toLocaleDateString()} {new Date(event.createdAt).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                     </span>
                  </div>
                  <p className="text-xs text-secondary">{event.description}</p>
                  {event.status && (
                     <span className="inline-block mt-2 text-[10px] px-2 py-0.5 rounded bg-background/40 text-secondary uppercase tracking-wider">
                        {event.status.replace('_', ' ')}
                     </span>
                  )}
               </div>
            </div>
         ))}
      </div>
   );
};